export default __webpack_public_path__ + "static/media/mercury.da15bb32.jpg";